export default __webpack_public_path__ + "static/media/Hair_5_M_C5.9a24950a.svg";